export const defaultConfig = {
  themeDirection: "ltr",
  presetColor: "muraena",
  fontFamily: [
    "Inter",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
  ].join(","),
};

export const urlsMenu = [
  "map",
  "api",
];

export const urlsUser = [
  "profile",
  "exit",
];